import MockElSelect from './mock-el-select.vue'

MockElSelect.install = function (Vue) {
	Vue.component(MockElSelect.name, MockElSelect);
}

export default MockElSelect;